import { CreateBase, Form, useGetIdentity } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { FormToolbar } from "../layout/FormToolbar";
import { LeadInputs } from "./LeadInputs";
import { cleanupLeadForSave } from "./leadModel";

export const LeadCreate = () => {
  const { identity } = useGetIdentity();

  return (
    <CreateBase redirect="show" transform={cleanupLeadForSave}>
      <div className="mt-2 flex lg:mr-72">
        <div className="flex-1">
          <Form
            defaultValues={{
              status: "New",
              sales_id: identity?.id,
              email_jsonb: [{ email: null, type: null }],
              phone_jsonb: [{ number: null, type: null }],
            }}
          >
            <Card>
              <CardContent>
                <LeadInputs />
                <FormToolbar />
              </CardContent>
            </Card>
          </Form>
        </div>
      </div>
    </CreateBase>
  );
};
